import { Link } from "@inertiajs/react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import { Card, CardContent } from "@/components/ui/Card"
import { Button } from "@/components/ui/Button"
import { dashboard_path } from "@/lib/routes"

export default function NotFound() {
  return (
    <AppLayout header={<PageTitle title="Page not found" subtitle="The page you're looking for doesn't exist or was moved." />}>
      <Card className="max-w-md">
        <CardContent className="flex flex-col items-start gap-4 pt-6">
          <p className="text-sm text-muted-foreground">
            Check the address, or head back to the dashboard.
          </p>
          <Button asChild>
            <Link href={dashboard_path()}>Back to dashboard</Link>
          </Button>
        </CardContent>
      </Card>
    </AppLayout>
  )
}
